import {setupAxios} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'
import {api} from './APIMiddlewares'

export async function getAdminAssets() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/assets/allUserAssets`, token, tenantId, false)
}

// form save api integration
export async function addAsset(InputField: {
  category: string
  subCategory: string
  brand: string
  serialNo: string
  description: string
  purchaseDate: string
  status: string
  assignee: string
}) {
  const {token, tenantId} = setupAxios()

  return await api
    .post(
      `/assets`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          category: InputField.category,
          subCategory: InputField.subCategory,
          brand: InputField.brand,
          serialNo: InputField.serialNo,
          description: InputField.description,
          purchaseDate: InputField.purchaseDate,
          status: InputField.status,
        }),
      },
      false
    )

    .then((res) => res)
}

export async function addAssetWithUser(
  formField: {
    user: string
    issueDate: string
    returnDate?: string
    location: string
    locationType: string
  },
  editId: string | null
) {
  const {token, tenantId} = setupAxios()

  return await api
    .post(
      `/assets/user`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          id: editId,
          user: {
            id: formField.user,
          },
          issueDate: formField.issueDate,
          returnDate: formField.returnDate || null, // ✅ ADD THIS
          location: formField.location,
          locationType: formField.locationType,
        }),
      },
      false
    )
    .then((res) => res)
}
export async function acknowledgeUserAsset(userAssetId: string) {
  const { token, tenantId } = setupAxios()
  return await api.put(
    `/assets/userAsset/${userAssetId}/acknowledge`,
    token,
    tenantId,
    {
      body: JSON.stringify({}) 
    },
    false
  )
}

//edit by id
export async function sendUpdateAssetEmail(
  InputField: {
    category: string
    subCategory: string
    brand: string
    serialNo: string
    description: string
    purchaseDate: string
    status: string
    assignee: string
  },
  id: string,
  userId: string,
  comment: string
) {
  const {token, tenantId} = setupAxios()
  return await api
    .put(
      `/assets/${id}/email`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          category: InputField.category,
          subCategory: InputField.subCategory,
          brand: InputField.brand,
          serialNo: InputField.serialNo,
          description: InputField.description,
          purchaseDate: InputField.purchaseDate,
          status: InputField.status,
          comment,
          user: {id: userId},
        }),
      },
      false
    )
    .then((res) => res)
}

//   get Assets

export async function getAssets(query: Record<string, string | number | undefined> = {}) {
  const {token, tenantId} = setupAxios()
  const params = new URLSearchParams()
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') params.set(key, String(value))
  })
  const queryString = params.toString()
  return await api.get(`/assets${queryString ? `?${queryString}` : ''}`, token, tenantId, false)
}

//getAssets by id

export async function getAssetsById(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/assets/${id}`, token, tenantId, false)
}

export async function getAssetsByUserId(userAssetId: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/assets/userAsset/${userAssetId}`, token, tenantId, false)
}
export async function getAssetsByUserIdforProfile(userId: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/assets/user/${userId}`, token, tenantId, false)
}

export async function addUserAsset(InputField: {
  category: string
  brand: string
  serialNo: string
  issueDate: string
  user: string
}) {
  const {token, tenantId} = setupAxios()

  return await api
    .post(
      `/assets/user`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          category: InputField.category,
          brand: InputField.brand,
          serialNo: InputField.serialNo,
          issueDate: InputField.issueDate,
          user: {
            id: InputField.user,
          },
        }),
      },
      false
    )
    .then((res) => res)
}
export async function updateUserAssetById(
  InputField: {
    category: string
    brand: string
    serialNo: string
    issueDate: string
    returnDate: string
    user: string
    // issueDate?: string;
    // returnDate?: string | null;
  },
  userAssetId: string
) {
  const {token, tenantId} = setupAxios()
  return await api
    .put(
      `/assets/userAsset/${userAssetId}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          user: {
            id: InputField.user,
          },
          category: InputField.category,
          brand: InputField.brand,
          serialNo: InputField.serialNo,
          issueDate: InputField.issueDate,
          returnDate: InputField.returnDate,
        }),
      },
      false
    )
    .then((res) => res)
}
export async function getUserAssets() {
  const {token, tenantId} = setupAxios()
  return await api.get(`/assets/user`, token, tenantId, false)
}

export async function getAllUserAssets() {
  const {token, tenantId} = setupAxios()
  return await api.get(`/assets/allUserAssets`, token, tenantId, false)
}
